import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import usePrivateLink from "../config/usePrivateLink";
import {
  studentDueFeeDetails,
  studentFeeDeposit,
  studentFeeReceiptNo,
} from "../../api/Student";
import { useLocation, useNavigate } from "react-router-dom";
import { BankList } from "../../api/BankService";

export default function StudentFeeDeposit() {
  usePrivateLink();

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [filters, setFilters] = useState({});

  const [fromFilters, setFromFilters] = useState({ batch_id: "" });

  const [setting, setSetting] = useState({});
  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));

    setFilters({
      id: searchParams.get("id") ?? false,
      type: searchParams.get("type") ?? false,
      student_id: searchParams.get("student_id") ?? false,
      library_student_id: searchParams.get("library_student_id") ?? false,
      hostel_student_id: searchParams.get("hostel_student_id") ?? false,
    });
  }, []);

  const [data, setData] = useState({});
  const [receiptNoData, setReceiptNoData] = useState({});
  const [banks, setBanks] = useState([]);

  const [formData, setFormData] = useState({
    receipt_no: "RCPT-1",
    amount: "",
    bank_id: "",
    transaction_no: "",
    remark: "",
    payment_date: "",
    next_payment_date: "",
    feeData: [],
  });

  useEffect(() => {
    receiptNoVerify();
  }, [formData?.receipt_no]);

  const receiptNoVerify = async () => {
    try {
      const response = await studentFeeReceiptNo(
        `receipt_no=${formData?.receipt_no}`,
      );
      if (response.data.status) {
        setReceiptNoData(response?.data?.data);
        if (formData.receipt_no === "RCPT-1") {
          setFormData((prev) => ({
            ...prev,
            receipt_no: response?.data?.data?.next_receipt_no,
          }));
        }
      } else {
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (error) {
      SweetAlertShow("error", "Error", error.message);
    }
  };

  const getDataList = async () => {
    if (
      !filters?.id &&
      !filters?.student_id &&
      !filters?.library_student_id &&
      !filters?.hostel_student_id
    ) {
      return null;
    }

    setLoading(true);

    try {
      let addUrl = "";
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value) {
          addUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      });

      const response = await studentDueFeeDetails(addUrl);
      if (response.data.status) {
        setData(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (error) {
      SweetAlertShow("error", "Error", error.message);
    } finally {
      setLoading(false);
    }
  };

  const getBankList = async () => {
    setLoading(true);
    try {
      const response = await BankList();
      if (response.data.status) {
        setBanks(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (error) {
      SweetAlertShow("error", "Error", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBankList();

    const today = new Date();
    const next = new Date();
    next.setMonth(next.getMonth() + 1);

    setFormData((prev) => ({
      ...prev,
      payment_date: today.toLocaleDateString("en-CA"),
      next_payment_date: next.toLocaleDateString("en-CA"),
    }));
  }, []);
  useEffect(() => {
    getDataList();
  }, [filters]);

  useEffect(() => {
    const course_n_fees =
      data?.course_n_fees?.filter((f) => {
        if (fromFilters?.batch_id) {
          return Number(f.batch_id) === Number(fromFilters?.batch_id);
        }
        return true;
      }) || [];

    const library_fees = data?.library_student_fees || [];
    const hostel_fees = data?.hostel_student_fees || [];
    const bus_fees = data?.bus_student_fees || [];
    const courseIds = course_n_fees.map((item) => item.id);
    const batchIds = course_n_fees.map((item) => item?.batch_id);
    const libraryIds = library_fees.map((item) => item.id);
    const hostelIds = hostel_fees.map((item) => item.id);
    const busIds = bus_fees.map((item) => item.id);

    const course_n_fees_totals = course_n_fees.reduce(
      (acc, item) => {
        acc.reg_total += Math.ceil(Number(item.reg_fee || 0));
        acc.reg_paid += Math.floor(Number(item.paid_reg_fee || 0));

        acc.tui_total += Math.ceil(Number(item.total_fee || 0));
        acc.tui_paid += Math.floor(Number(item.fees_paid || 0));

        return acc;
      },
      {
        reg_total: 0,
        reg_paid: 0,
        tui_total: 0,
        tui_paid: 0,
        bus_total: 0,
        bus_paid: 0,
      },
    );
    const library_fees_totals = library_fees.reduce(
      (acc, item) => {
        acc.total += Math.ceil(Number(item.final_amount || 0));
        acc.paid += Math.floor(Number(item.paid_amount || 0));
        return acc;
      },
      {
        total: 0,
        paid: 0,
      },
    );

    const hostel_fees_totals = hostel_fees.reduce(
      (acc, item) => {
        acc.total += Math.ceil(Number(item.final_amount || 0));
        acc.paid += Math.floor(Number(item.paid_amount || 0));
        return acc;
      },
      {
        total: 0,
        paid: 0,
      },
    );

    const bus_fees_totals = bus_fees.reduce(
      (acc, item) => {
        acc.total += Math.ceil(Number(item.amount || 0));
        acc.paid += Math.floor(Number(item.paid_amount || 0));

        return acc;
      },
      {
        total: 0,
        paid: 0,
      },
    );

    const reg_pending =
      course_n_fees_totals.reg_total - course_n_fees_totals.reg_paid;
    const tui_pending =
      course_n_fees_totals.tui_total - course_n_fees_totals.tui_paid;
    const bus_fees_pending = bus_fees_totals.total - bus_fees_totals.paid;
    const library_fees_pending =
      library_fees_totals.total - library_fees_totals.paid;
    const hostel_fees_pending =
      hostel_fees_totals.total - hostel_fees_totals.paid;

    setFormData((prev) => ({
      ...prev,
      feeData: [
        {
          name: "Registration Fee",
          ids: courseIds,
          batch_id: batchIds,
          total: course_n_fees_totals.reg_total,
          paid: course_n_fees_totals.reg_paid,
          pending: reg_pending,
          selected: reg_pending > 0 ? true : false,
          payAmount: reg_pending,
        },
        {
          name: "Tuition Fee",
          ids: courseIds,
          batch_id: batchIds,
          total: course_n_fees_totals.tui_total,
          paid: course_n_fees_totals.tui_paid,
          pending: tui_pending,
          selected: tui_pending > 0 ? true : false,
          payAmount: tui_pending,
        },
        {
          name: "Transport Fee",

          ids: busIds,
          total: bus_fees_totals.total,

          paid: bus_fees_totals.paid,

          pending: bus_fees_pending,

          selected: bus_fees_pending > 0 ? true : false,

          payAmount: bus_fees_pending,
        },
        {
          name: "Hostel Fee",
          ids: hostelIds,
          total: hostel_fees_totals.total,
          paid: hostel_fees_totals.paid,
          pending: hostel_fees_pending,
          selected: hostel_fees_pending > 0 ? true : false,
          payAmount: hostel_fees_pending,
        },
        {
          name: "Library Fee",
          ids: libraryIds,
          total: library_fees_totals.total,
          paid: library_fees_totals.paid,
          pending: library_fees_pending,
          selected: library_fees_pending > 0 ? true : false,
          payAmount: library_fees_pending,
        },
      ],
      amount:
        reg_pending +
        tui_pending +
        bus_fees_pending +
        library_fees_pending +
        hostel_fees_pending,
    }));
  }, [data, fromFilters]);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await studentFeeDeposit(formData);
      if (response.data.status) {
        navigate(`/student/fees/receipt?id=${response?.data?.data?.id}`);
        SweetAlertShow("success", "Successfully", response.data.message);
      } else {
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (error) {
      SweetAlertShow("error", "Error", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckbox = (index) => {
    const updated = [...formData.feeData];
    const clickedFee = updated[index];

    clickedFee.selected = !clickedFee.selected;

    if (clickedFee.name === "Tuition Fee" && clickedFee.selected) {
      const regIndex = updated.findIndex((f) => f.name === "Registration Fee");
      if (regIndex !== -1) {
        updated[regIndex].selected = true;
        updated[regIndex].payAmount = updated[regIndex].pending;
      }
    }

    if (clickedFee.name === "Registration Fee" && !clickedFee.selected) {
      const tuition = updated.find((f) => f.name === "Tuition Fee");
      if (tuition?.selected) {
        return;
      }
    }

    if (!clickedFee.selected) {
      clickedFee.payAmount = 0;
    }

    const totalSelectedAmount = updated.reduce((sum, fee) => {
      return fee.selected ? sum + Math.ceil(Number(fee.payAmount || 0)) : sum;
    }, 0);

    setFormData((prev) => ({
      ...prev,
      feeData: updated,
      amount: totalSelectedAmount,
    }));
  };

  const handleAmountChange = (index, value) => {
    const updated = [...formData.feeData];

    let amount = Math.ceil(Number(value || 0));
    if (updated[index].name !== "Hostel Fee") {
      if (amount > updated[index].pending) {
        amount = updated[index].pending;
      }
    }

    updated[index].payAmount = amount;

    const total = updated.reduce((sum, fee) => {
      return fee.selected ? sum + Math.ceil(Number(fee.payAmount || 0)) : sum;
    }, 0);

    setFormData((prev) => ({
      ...prev,
      feeData: updated,
      amount: total,
    }));
  };

  const handleTotalAmountChange = (value) => {
    let amount = Math.ceil(Number(value || 0));

    const hostelFee = formData.feeData.find((f) => f.name === "Hostel Fee");

    const isHostelSelected = hostelFee?.selected;

    const nonHostelPending = formData?.feeData
      ?.filter((f) => f.name !== "Hostel Fee")
      .reduce((sum, item) => sum + Math.ceil(Number(item.pending || 0)), 0);

    if (!isHostelSelected && amount > nonHostelPending) {
      amount = nonHostelPending;
    }

    let remaining = amount;

    const priorityOrder = [
      "Registration Fee",
      "Tuition Fee",
      "Transport Fee",
      "Hostel Fee",
      "Library Fee",
    ];

    const updated = priorityOrder.map((type) => {
      const fee = formData.feeData.find((f) => f.name === type);

      if (!fee || !fee.selected) {
        return { ...fee, payAmount: 0 };
      }

      let pay = 0;

      if (remaining > 0) {
        if (fee.name === "Hostel Fee" && isHostelSelected) {
          pay = remaining;
          remaining = 0;
        } else {
          pay = Math.min(fee.pending, remaining);
          remaining -= pay;
        }
      }

      return {
        ...fee,
        payAmount: pay,
      };
    });

    setFormData((prev) => ({
      ...prev,
      amount: amount,
      feeData: updated,
    }));
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="container-fluid flex-grow-1 container-p-y">
              <div className="row g-3">
                <div className="col-md-5">
                  <div className="card">
                    <div className="card-header bg-label-primary text-white">
                      <strong>
                        {data?.name} ({data?.registration_no})
                      </strong>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="table-primary">
                          <tr className="table-primary">
                            <th>Type</th>
                            <th>Total</th>
                            <th>Paid</th>
                            <th>Pending</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData?.feeData?.map((f) => {
                            if (f.total === 0) return null;
                            return (
                              <tr key={f.name}>
                                <td>{f.name}</td>
                                <td>&#8377;{f.total}</td>
                                <td>&#8377;{f.paid}</td>
                                <td>&#8377;{f.pending}</td>
                              </tr>
                            );
                          })}
                          <tr className="fw-bold">
                            <td>Total</td>
                            <td>
                              &#8377;
                              {formData?.feeData?.reduce(
                                (total, item) =>
                                  total + Math.ceil(Number(item.total || 0)),
                                0,
                              )}
                            </td>
                            <td>
                              &#8377;
                              {formData?.feeData?.reduce(
                                (paid, item) =>
                                  paid + Math.ceil(Number(item.paid || 0)),
                                0,
                              )}
                            </td>
                            <td>
                              &#8377;
                              {formData?.feeData?.reduce(
                                (pending, item) =>
                                  pending +
                                  Math.ceil(Number(item.pending || 0)),
                                0,
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {data?.student_emi?.length > 0 && (
                    <div className="mt-3">
                      <div className="card border shadow-none">
                        <div className="card-header py-2 bg-label-primary">
                          <strong>EMI Details</strong>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-sm table-bordered mb-0">
                            <thead>
                              <tr>
                                <th>EMI</th>
                                <th>Emi Date</th>
                                <th>Amount</th>
                                <th>Paid</th>
                                <th>Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.student_emi?.map((item, index) => (
                                <tr key={item?.id}>
                                  <td>EMI {index + 1}</td>

                                  <td>{item?.emi_date}</td>

                                  <td>₹{item?.emi_amount}</td>

                                  <td>₹{item?.paid_amount}</td>

                                  <td>
                                    <span
                                      className={`badge ${
                                        item?.emi_payment_status === "Paid"
                                          ? "bg-success"
                                          : "bg-danger"
                                      }`}
                                    >
                                      {item?.emi_payment_status}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-7">
                  <form onSubmit={handleSubmit}>
                    <div className="card">
                      <div className="card-header bg-label-primary ">
                        <div className="row align-items-center justify-content-between ">
                          <div className="col-6 text-white fw-bold text-primary">
                            Deposit Payment
                          </div>
                          <div className="col-6 p-0">
                            <div className="form-floating form-floating-outline p-0">
                              <input
                                type="text"
                                name="receipt_no"
                                id="receipt_no"
                                className="form-control p-0 px-2"
                                placeholder="Enter Receipt No"
                                value={formData?.receipt_no}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    receipt_no: e.target.value,
                                  })
                                }
                                required
                              />
                              <label htmlFor="receipt_no">
                                Receipt No <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            {receiptNoData?.message && (
                              <span className="text-danger small">
                                {receiptNoData.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row g-4 my-2">
                          <input
                            type="hidden"
                            name="student_id"
                            id="student_id"
                            value={data?.student_id}
                          />
                          <input
                            type="hidden"
                            name="hostel_student_id"
                            id="hostel_student_id"
                            value={data?.hostel_student_id}
                          />
                          <input
                            type="hidden"
                            name="library_student_id"
                            id="library_student_id"
                            value={data?.library_student_id}
                          />
                          <input
                            type="hidden"
                            name="bus_student_id"
                            id="bus_student_id"
                            value={data?.bus_student_id}
                          />
                          {data?.course_n_fees?.length > 1 && (
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-control px-2 py-1"
                                  onChange={(e) =>
                                    setFromFilters({
                                      ...fromFilters,
                                      batch_id: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">All</option>
                                  {data?.course_n_fees?.map((item) => (
                                    <option value={item?.batch?.id}>
                                      {item?.batch?.title}
                                    </option>
                                  ))}
                                </select>
                                <label htmlFor="amount">Select Batch</label>
                              </div>
                            </div>
                          )}
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="number"
                                name="amount"
                                id="amount"
                                className="form-control"
                                placeholder="Enter Amount"
                                min={0}
                                value={formData?.amount}
                                onChange={(e) =>
                                  handleTotalAmountChange(e.target.value)
                                }
                                required
                              />
                              <label htmlFor="amount">
                                Amount <sup className="text-danger">*</sup>
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="bank_id"
                                id="bank_id"
                                className="form-select"
                                required
                                value={formData?.bank_id ?? ""}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    bank_id: e.target.value,
                                  })
                                }
                              >
                                <option disabled value="">
                                  Select Bank
                                </option>
                                {banks?.map((item, index) => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.account_no}:({item?.owner_name}):(
                                    {item?.id})
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="bank_id">
                                Select Bank<sup className="text-danger">*</sup>
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                name="transaction_no"
                                id="transaction_no"
                                className="form-control"
                                placeholder="Enter Transaction No"
                                value={formData?.transaction_no}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    transaction_no: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="transaction_no">
                                Transaction No
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <textarea
                                name="remark"
                                id="remark"
                                className="form-control input-uppercase"
                                placeholder="Enter Remark"
                                value={formData?.remark}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    remark: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="remark">Remark</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                name="payment_date"
                                id="payment_date"
                                className="form-control"
                                value={formData?.payment_date}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    payment_date: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="payment_date">Payment Date</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                name="next_payment_date"
                                id="next_payment_date"
                                className="form-control"
                                value={formData?.next_payment_date}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    next_payment_date: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="next_payment_date">
                                Next Payment Date
                              </label>
                            </div>
                          </div>
                          <div className="col-12">
                            {(() => {
                              let i = -1;
                              return formData?.feeData?.map((fee, index) => {
                                if (fee.pending === 0) return null;
                                if (fee.selected) {
                                  i++;
                                }
                                return (
                                  <div
                                    key={fee.name}
                                    className="row align-items-center mb-1"
                                  >
                                    <div className="col-4">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name={`module[${i}][type]`}
                                          value={fee.name}
                                          id={index}
                                          checked={fee.selected}
                                          onChange={() => {
                                            handleCheckbox(index);

                                            // if (
                                            //   fee.name !== "Registration Fee"
                                            // ) {
                                            //   handleCheckbox(index);
                                            // }
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={index}
                                        >
                                          {fee.name}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-4">
                                      <input
                                        type="hidden"
                                        className="form-control px-2 py-1"
                                        name={`module[${i}][ids]`}
                                        value={fee.ids}
                                        disabled={!fee.selected}
                                      />
                                      <input
                                        type="number"
                                        className="form-control px-2 py-1"
                                        value={fee.payAmount}
                                        min={0}
                                        name={`module[${i}][amount]`}
                                        disabled={!fee.selected}
                                        max={
                                          fee.name === "Hostel Fee"
                                            ? undefined
                                            : fee.pending
                                        }
                                        onChange={(e) => {
                                          if (fee.name !== "Registration Fee") {
                                            handleAmountChange(
                                              index,
                                              e.target.value,
                                            );
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              });
                            })()}
                          </div>
                          <div className="col-9">
                            {setting?.message_status === "Yes" && (
                              <div className="col-md-12">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sendMessage"
                                    name="sendMessage"
                                    defaultChecked={true}
                                    value={1}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="sendMessage"
                                  >
                                    Send Message
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="col-3 text-end">
                            <button type="submit" className="btn btn-primary">
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
